export const Building2Icon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.55487 27.6188C1.84612 27.6188 1.24312 27.3701 0.745875 26.8729C0.248625 26.3756 0 25.7726 0 25.0639V8.75138C0 8.04013 0.248625 7.435 0.745875 6.936C1.24312 6.437 1.84612 6.1875 2.55487 6.1875H6.1875V2.56387C6.1875 1.85262 6.43613 1.2475 6.93338 0.748501C7.43063 0.249501 8.03363 0 8.74238 0H18.8674C19.5786 0 20.1837 0.249501 20.6827 0.748501C21.1818 1.2475 21.4313 1.85262 21.4313 2.56387V12.375H25.0549C25.7661 12.375 26.3713 12.6245 26.8703 13.1235C27.3693 13.6225 27.6188 14.2276 27.6188 14.9389V25.0639C27.6188 25.7726 27.3693 26.3756 26.8703 26.8729C26.3713 27.3701 25.7661 27.6188 25.0549 27.6188H15.7924V21.1264H11.8174V27.6188H2.55487ZM2.55487 25.0639H6.49238V21.1264H2.55487V25.0639ZM2.55487 18.8764H6.49238V14.9389H2.55487V18.8764ZM2.55487 12.6889H6.49238V8.75138H2.55487V12.6889ZM8.74238 18.8764H12.6799V14.9389H8.74238V18.8764ZM8.74238 12.6889H12.6799V8.75138H8.74238V12.6889ZM8.74238 6.50138H12.6799V2.56387H8.74238V6.50138ZM14.9299 18.8764H18.8674V14.9389H14.9299V18.8764ZM14.9299 12.6889H18.8674V8.75138H14.9299V12.6889ZM14.9299 6.50138H18.8674V2.56387H14.9299V6.50138ZM21.1174 25.0639H25.0549V21.1264H21.1174V25.0639ZM21.1174 18.8764H25.0549V14.9389H21.1174V18.8764Z"
        fill="currentColor"
      />
    </svg>
  );
};
